<template>
    <div>
        <van-nav-bar
            title="办卡套餐"
            left-text="返回"
            left-arrow
            @click-left="clickback"
        />
        <van-tabs type="card" color="#488aff" style="width:100%;">
            <van-loading vertical v-if="loading"/>
            <van-tab title="储值套餐">
                <van-cell v-for="item in rechargePackageList" :key="item.id" title="储值套餐" :value="'有效期：'+item.validity_period+'个月'" size="large">
                    <template slot="label">
                        <span style="display:block;">{{"套餐金额："}}{{item.amount_package}}</span>
                        <span style="display:block;">{{"实付金额："}}{{item.real_payment}}</span>
                    </template>
                </van-cell>
            </van-tab>
            <van-tab title="美容套餐">
                <van-cell v-for="item in beautyPackageList" :key="item.id" :title="item.name" :value="item.price" size="large">
                    <template slot="label">
                        <span style="display:block;" v-for="itemservice in item.service_details" :key="itemservice.repair_service_id">
                            {{itemservice.name}}：{{itemservice.amount}}次
                        </span>
                        <span style="display:block;width:160%;" v-for="itemversion in item.version_details" :key="itemversion.version1_id">
                            {{itemversion.name}}：{{itemversion.amount}}个
                        </span>
                    </template>
                </van-cell>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import { NavBar, Tab, Tabs, Cell, Loading } from 'vant';
import { BeautyPackageApi, VipRechargePackageApi } from '@/api/shop'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Cell.name]: Cell,
        [Loading.name]: Loading
    },
    data() {
        return {
            beautyPackageList:[],
            rechargePackageList:[],
            loading: true
        }
    },
    mounted(){
        this.getBeautyPackage()
        this.getRechargePackage()
    },
    methods: {
        getBeautyPackage(){
            var that = this
            that.axios.get(BeautyPackageApi).then((ret) => {
                that.beautyPackageList = ret
            })
        },
        getRechargePackage(){
            var that = this
            that.axios.get(VipRechargePackageApi).then((ret) => {
                that.rechargePackageList = ret
                that.loading = false
            })
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/membercentre`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
</style>